export default "__VITE_ASSET__B6oAsz3c__"